import DataStoreRecordBehaviors from '../collaboration/DataStoreRecordBehaviors';
import { type SortableItem } from '../models/ItemCollection';

export interface SelectOptionData extends SortableItem {
  name: string;
  color: string;
}

interface SelectOption extends SelectOptionData {}

class SelectOption extends DataStoreRecordBehaviors(Object) {
  serializedKeys = ['id', 'name', 'color'];

  constructor(values: Partial<SelectOptionData>) {
    super();

    Object.assign(this, values);
  }
}

export default SelectOption;
